// extracted by mini-css-extract-plugin
export default {"testi":"testimonials_testi__3dxm+","testi_slide":"testimonials_testi_slide__5rLYw"};